import { render, staticRenderFns } from "./alert-consolidado.vue?vue&type=template&id=3d86794c&scoped=true"
import script from "./alert-consolidado.vue?vue&type=script&lang=js"
export * from "./alert-consolidado.vue?vue&type=script&lang=js"
import style0 from "./alert-consolidado.vue?vue&type=style&index=0&id=3d86794c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86794c",
  null
  
)

export default component.exports